import classnames from 'classnames';
import React from 'react';

import {Button, Icon} from '@albert-io/atomic';
import {history} from 'client/history';

import type {EmptyStateSubject} from './useAdaptiveEmptyStateSubjects';

/** The designed "View All Adaptive" destination. */
const ADAPTIVE_SUBJECTS_PATH = '/subjects';

/**
 * Domain-coloured links into the teacher's adaptive subjects, plus a catch-all. The action row on
 * every adaptive empty state — both lists send the teacher to the same place to get started.
 */
export const AdaptiveSubjectLinks = ({
  subjects,
  align = 'center'
}: {
  subjects: EmptyStateSubject[];
  align?: 'center' | 'start';
}) => (
  <div
    className={classnames('gap-x1 flex flex-wrap items-center', {
      'justify-center': align === 'center'
    })}
  >
    {subjects.map((subject) => (
      <Button
        key={subject.id}
        className={`!background-domain-${subject.curriculumAreaSlug} content-primary-inverse-static! gap-x0-half inline-flex items-center`}
        roundness='pill'
        variant='solid'
        onClick={() => history.pushState(null, `/adaptive-subjects/${subject.urlSlug}`)}
      >
        {subject.name}
        <Icon
          color='primary-inverse-static'
          icon='arrow-up-right'
          iconStyle='regular'
          size='inherit'
        />
      </Button>
    ))}
    <Button
      color='secondary'
      roundness='pill'
      variant='outlined'
      onClick={() => history.pushState(null, ADAPTIVE_SUBJECTS_PATH)}
    >
      View All Adaptive
    </Button>
  </div>
);
